import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=737b8484&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"
import style0 from "./shop.vue?vue&type=style&index=0&id=737b8484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737b8484",
  null
  
)

export default component.exports